import { ca } from '@cian/analytics';

export const trackTransferToDeveloperCard = () => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'CardJK',
    action: 'click_sopr',
    label: 'to_card_builder',
    useLastProducts: true,
  });
};
